import { render } from "./PDFTestAllObjects.vue?vue&type=template&id=d2ef0652"
import script from "./PDFTestAllObjects.vue?vue&type=script&lang=js"
export * from "./PDFTestAllObjects.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__